module.exports = __webpack_public_path__ + "static/img/plus.895a0fab.png";